// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Animation for Like Button */
@keyframes heart-beat {
    0% {
        transform: scale(1);
    }

    25% {
        transform: scale(1.3);
    }

    50% {
        transform: scale(1);
    }

    75% {
        transform: scale(1.3);
    }

    100% {
        transform: scale(1);
    }
}

.like-button-animate {
    animation: heart-beat 0.4s ease-in-out;
}

.like-button-active {
    color: var(--primary-color);
}`, "",{"version":3,"sources":["webpack://./src/components/LikeAnimation.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":["/* Animation for Like Button */\r\n@keyframes heart-beat {\r\n    0% {\r\n        transform: scale(1);\r\n    }\r\n\r\n    25% {\r\n        transform: scale(1.3);\r\n    }\r\n\r\n    50% {\r\n        transform: scale(1);\r\n    }\r\n\r\n    75% {\r\n        transform: scale(1.3);\r\n    }\r\n\r\n    100% {\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n.like-button-animate {\r\n    animation: heart-beat 0.4s ease-in-out;\r\n}\r\n\r\n.like-button-active {\r\n    color: var(--primary-color);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
